import {
  type QBankStructureLevel,
  QBankStructureLevelCategory,
} from '@exam-management/qbs-provider';
import { getLocationSchema } from '@exam-management/qcontent-management';
import { z } from 'zod';

export function getQuestionDuplicateSchema(qbsLevels: QBankStructureLevel[]) {
  return z.object({
    [QBankStructureLevelCategory.Part]: getLocationSchema(
      QBankStructureLevelCategory.Part,
      qbsLevels,
    ),
    [QBankStructureLevelCategory.Subject]: getLocationSchema(
      QBankStructureLevelCategory.Subject,
      qbsLevels,
    ),
    [QBankStructureLevelCategory.Group]: getLocationSchema(
      QBankStructureLevelCategory.Group,
      qbsLevels,
    ),
    [QBankStructureLevelCategory.Chapter]: getLocationSchema(
      QBankStructureLevelCategory.Chapter,
      qbsLevels,
    ),
    [QBankStructureLevelCategory.Topic]: getLocationSchema(
      QBankStructureLevelCategory.Topic,
      qbsLevels,
    ),
    [QBankStructureLevelCategory.SubTopic]: getLocationSchema(
      QBankStructureLevelCategory.SubTopic,
      qbsLevels,
    ),
  });
}

export type QuestionDuplicationFormInput = z.infer<ReturnType<typeof getQuestionDuplicateSchema>>;
